import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ITransportationNeeds } from '../models/transportationNeeds';
import { ErrorService } from '../helpers/errorService';

@Injectable({
    providedIn: 'root'
})
export class TransportationNeedsService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getTransportationNeeds(buildingId: string): Observable<{has_error: boolean, message: string, data: ITransportationNeeds}> {
        const url = environment.apiBaseUrl + endpoints.getTransportationNeeds.replace(':buildingId', buildingId);
        return this.http.get<{has_error: boolean, message: string, data: ITransportationNeeds}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateTransportationNeeds(buildingId: string, data: Partial<ITransportationNeeds>): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.updateTransportationNeeds.replace(':buildingId', buildingId);
        return this.http.post<{has_error: boolean, message: string, data: any}>(url, data).pipe(
            catchError(this.errorService.handleError)
        );
    }
}
